export const ShareIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2665_1608)">
      <path d="M8.50016 2.97658L6.84316 4.63358C6.53938 4.93737 6.53938 5.43447 6.84316 5.73825C7.14695 6.04203 7.64405 6.04203 7.94783 5.73825L9.60483 4.08125C10.5162 3.1699 12.0075 3.1699 12.9188 4.08125C13.8302 4.9926 13.8302 6.4839 12.9188 7.39525L11.2618 9.05225C10.958 9.35604 10.958 9.85314 11.2618 10.1569C11.5656 10.4607 12.0627 10.4607 12.3665 10.1569L14.0235 8.49992C15.5479 6.97548 15.5479 4.50102 14.0235 2.97658C12.4991 1.45214 10.0246 1.45214 8.50016 2.97658ZM6.29083 10.7093C6.59461 11.013 7.09171 11.013 7.3955 10.7093L10.7095 7.39525C11.0133 7.09147 11.0133 6.59437 10.7095 6.29058C10.4057 5.9868 9.90861 5.9868 9.60483 6.29058L6.29083 9.60459C5.98705 9.90837 5.98705 10.4055 6.29083 10.7093ZM9.0525 11.2616L7.3955 12.9186C6.48415 13.8299 4.99284 13.8299 4.08149 12.9186C3.17014 12.0072 3.17014 10.5159 4.08149 9.60459L5.73849 7.94758C6.04228 7.6438 6.04228 7.1467 5.73849 6.84292C5.43471 6.53913 4.93761 6.53913 4.63383 6.84292L2.97683 8.49992C1.45239 10.0244 1.45239 12.4988 2.97683 14.0233C4.50127 15.5477 6.97572 15.5477 8.50016 14.0233L10.1572 12.3663C10.4609 12.0625 10.4609 11.5654 10.1572 11.2616C9.85338 10.9578 9.35628 10.9578 9.0525 11.2616Z" />
    </g>
    <defs>
      <clipPath id="clip0_2665_1608">
        <rect width="16" height="16" transform="translate(0.5 0.5)" />
      </clipPath>
    </defs>
  </svg>
);
